import { useMemo } from 'react';
import { useUserRights } from '../context/UserRightsContext';

/**
 * Standard page-level rights for a function code.
 * Harmonate users get full access; others follow core.user_rights flags.
 */
export const useFunctionPermissions = (functionCode) => {
  const { hasPermission, canAccessMenu, isHarmonateUser, loading, rightsLoaded } = useUserRights();

  return useMemo(() => {
    const allow = (action) => Boolean(isHarmonateUser || hasPermission(functionCode, action));
    return {
      functionCode,
      isHarmonateUser: Boolean(isHarmonateUser),
      loading,
      rightsLoaded,
      canAccess: Boolean(isHarmonateUser || canAccessMenu(functionCode)),
      canView: allow('view'),
      canAdd: allow('add'),
      canEdit: allow('edit'),
      canDelete: allow('delete'),
      canUpload: allow('upload'),
      canExport: allow('export'),
      canEnable: allow('enable'),
    };
  }, [functionCode, hasPermission, canAccessMenu, isHarmonateUser, loading, rightsLoaded]);
};

export default useFunctionPermissions;
